<template>
  <section class="text-primary py-12 sm:py-16 px-4" style="background-color: #CBDDD1;" data-newsletter>
    <div class="max-w-2xl mx-auto text-center">
      <h2 class="text-2xl sm:text-3xl xl:text-4xl font-header font-bold mb-3 sm:mb-4">
        Subscribe to Our Newsletter
      </h2>
      <p class="text-gray-900 mb-6 sm:mb-8 text-base sm:text-lg font-body px-4">
        Subscribe to our newsletter for the latest book releases, author events, and exclusive offers.
      </p>
      <form @submit.prevent="handleSubscribe" class="flex flex-col gap-4 max-w-md mx-auto">
        <input type="email" v-model="email" placeholder="Enter your email"
          class="w-full px-4 py-3 rounded-md bg-white text-black border border-gray-300 focus:outline-none focus:ring-1 focus:ring-black focus:border-black font-body"
          required :disabled="loading" />
        <div class="flex gap-4 items-center">
          <label class="text-sm font-body text-gray-900">Language:</label>
          <label class="flex items-center">
            <input type="radio" v-model="language" value="english" class="mr-2" :disabled="loading" />
            <span class="font-body">English</span>
          </label>
          <label class="flex items-center">
            <input type="radio" v-model="language" value="french" class="mr-2" :disabled="loading" />
            <span class="font-body">French</span>
          </label>
        </div>
        <button type="submit" :disabled="loading"
          class="bg-accent text-white px-8 py-3 rounded-md hover:bg-green-700 transition-colors font-body font-medium whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed">
          {{ loading ? 'Subscribing...' : 'Subscribe' }}
        </button>
      </form>
      <div v-if="message"
        :class="['mt-4 text-sm font-body', messageType === 'success' ? 'text-green-700' : 'text-red-600']">
        {{ message }}
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { publicService } from '../services/public.js'

const email = ref('')
const language = ref('english')
const loading = ref(false)
const message = ref('')
const messageType = ref('')

const handleSubscribe = async () => {
  if (!email.value || !email.value.includes('@')) {
    message.value = 'Please enter a valid email address'
    messageType.value = 'error'
    return
  }

  loading.value = true
  message.value = ''
  messageType.value = ''

  try {
    await publicService.subscribeNewsletter(email.value, language.value)
    message.value = 'Please check your email to confirm your subscription'
    messageType.value = 'success'
    email.value = ''
    language.value = 'english'
  } catch (error) {
    console.error('Failed to subscribe:', error)
    message.value = error.response?.data?.error || 'Failed to subscribe. Please try again.'
    messageType.value = 'error'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped></style>
